export function loadScript(
  url: string,
  addScriptToHead: boolean,
  options?: { load?: 'defer' | 'async'; language?: string; type?: string },
  innerHtml?: string,
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject());

    if (url) {
      script.setAttribute('src', url);
    }
    if (options) {
      if (options.load && options.load === 'async') {
        script.setAttribute('async', 'true');
      }
      if (options.load && options.load === 'defer') {
        script.setAttribute('defer', 'true');
      }
      if (options.language) {
        script.setAttribute('language', options.language);
      }
      if (options.type) {
        script.setAttribute('type', options.type);
      }
    }
    if (innerHtml) {
      script.innerHTML = innerHtml;
    }
    if (addScriptToHead) {
      document.head.appendChild(script);
      return;
    }
    document.body.appendChild(script);
  });
}

export function loadStylesheet(url: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    link.addEventListener('load', () => resolve());
    link.addEventListener('error', () => reject());
    document.head.appendChild(link);
  });
}
